var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRaportet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fbfbfb",
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,2h-4.2C11.3,0.4,9.6-0.4,8,0.2C7.2,0.5,6.5,1.1,6.2,2H2C0.9,2,0,2.9,0,4v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V4C18,2.9,17.1,2,16,2z M9,2c0.6,0,1,0.4,1,1S9.6,4,9,4S8,3.6,8,3S8.4,2,9,2z M10,16H5c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1h5c0.6,0,1,0.4,1,1C11,15.6,10.6,16,10,16z M13,12H5c-0.6,0-1-0.4-1-1s0.4-1,1-1h8c0.6,0,1,0.4,1,1S13.6,12,13,12z M13,8H5C4.4,8,4,7.6,4,7s0.4-1,1-1h8c0.6,0,1,0.4,1,1S13.6,8,13,8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRaportet);
export default __webpack_public_path__ + "static/media/icon_raportet.010eb2e26fd99f4c3c028502fe9b7835.svg";
export { ForwardRef as ReactComponent };